module.exports = __webpack_public_path__ + "assets/23da2621ca3a808124e964147ff3f891.mp4";